// extracted by mini-css-extract-plugin
export default {"wrapper":"Game_wrapper__3TM99","iframe":"Game_iframe__gVjrz"};